module.exports = __webpack_public_path__ + "assets/scene--empty.d6e80356.svg";